import React from 'react';
const OktaContext = React.createContext(null);
export const useOktaAuth = () => React.useContext(OktaContext);
export default OktaContext;
